/**
 * Get icon styles for IconButton context.
 * For IconButton, icons should always inherit the button's color
 * to match UIComponents behavior.
 */
export const getIconButtonIconStyles = () => {
  return {
    color: 'inherit'
  };
};